module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8019.e7f020e3.png";